import { ChangeEvent, FC, FocusEvent } from 'react';
import { InputText } from '@lambdacurry/component-library';
import { InputGrid, InputState } from '..';

export interface AddressInputGroupProps {
  name?: string;
  onBlur?: (event: FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => void;
  onChange?: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

export const AddressInputGroup: FC<AddressInputGroupProps> = ({ name, onBlur, onChange }) => {
  const fieldPrefix = name ? `${name}.` : '';

  const handleBlur = (event: FocusEvent<HTMLTextAreaElement | HTMLInputElement, Element>) => onBlur && onBlur(event);
  const handleChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => onChange && onChange(event);

  return (
    <InputGrid>
      <InputText name={`${fieldPrefix}line1`} onBlur={handleBlur} onChange={handleChange} label="Address" />
      <InputText name={`${fieldPrefix}line2`} onBlur={handleBlur} onChange={handleChange} label="Address 2" />

      <InputGrid>
        <div className="md:col-span-4">
          <InputText name={`${fieldPrefix}city`} onBlur={handleBlur} onChange={handleChange} label="City" />
        </div>
        <div className="md:col-span-4">
          <InputState name={`${fieldPrefix}state`} onBlur={handleBlur} onChange={handleChange} />
        </div>
        <div className="md:col-span-4">
          <InputText name={`${fieldPrefix}postal_code`} onBlur={handleBlur} onChange={handleChange} label="ZIP Code" />
        </div>
      </InputGrid>
    </InputGrid>
  );
};
